import GeoRasterLayer from 'georaster-layer-for-leaflet'
import {parseGeoraster} from '../libs/georaster';


const RasterService = {

  createRaster(input, pixelValuesToColorFn, config) {
    const {
      opacity,
      customDrawFunction,
      resolution
    } = config;

    return new Promise((resolve) => {
      parseGeoraster(input).then(georaster => {
        let options = {
          georaster,
          opacity,
          resolution: resolution || 256,
          debugLevel: 0,
        };

        if (customDrawFunction) {
          options.customDrawFunction = customDrawFunction;
        }

        if (typeof pixelValuesToColorFn === 'function') {
          options.pixelValuesToColorFn = pixelValuesToColorFn;
        }

        const raster = new GeoRasterLayer(options);
        resolve(raster);
      });
    });
  },
};

export {
  RasterService
};